(() => {
  'use strict';

  const SELECTOR = '[data-faj-bulk-order]';

  function init(section) {
    if (!section || section.dataset.fbofInitialized === 'true') return;
    section.dataset.fbofInitialized = 'true';

    const form = section.querySelector('[data-native-contact-form]');
    const button = section.querySelector('[data-submit-button]');
    const success = section.querySelector('[data-form-success]');
    const errors = section.querySelector('[data-form-errors]');

    if (success || errors) {
      const message = success || errors;
      window.requestAnimationFrame(() => {
        message.focus({ preventScroll: true });
        message.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth',
          block: 'center'
        });
      });
    }

    if (form && button) {
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;

        const label = button.querySelector('span');
        const loadingLabel = button.dataset.loadingLabel;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        if (label && loadingLabel) {
          label.textContent = loadingLabel;
        }
      });
    }
  }

  function initAll(scope = document) {
    if (scope.matches?.(SELECTOR)) init(scope);
    scope.querySelectorAll?.(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
